/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommunicationStatsDto } from '../models/CommunicationStatsDto';
import type { ContactActivitySearchResultDto } from '../models/ContactActivitySearchResultDto';
import type { TaskDueDatesStatsDto } from '../models/TaskDueDatesStatsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ContactActivityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search contact activities with server-side filtering on typed ContactActivity columns.
     * @param orgGuid
     * @param workflowDefinitionGuids
     * @param includeArchived
     * @param entityGuid
     * @param contactNameSearch
     * @param housingApplicationSearch
     * @param createdByUserGuids
     * @param assignedToUserGuids
     * @param statusCodes
     * @param interactionType
     * @param direction
     * @param isImportant
     * @param dateFrom
     * @param dateTo
     * @param dateField
     * @param primaryEmailSearch
     * @param primaryPhoneSearch
     * @param skip
     * @param take
     * @param ignoreFilters
     * @returns ContactActivitySearchResultDto OK
     * @throws ApiError
     */
    public search(
        orgGuid: string,
        workflowDefinitionGuids?: Array<string>,
        includeArchived: boolean = false,
        entityGuid?: string,
        contactNameSearch?: string,
        housingApplicationSearch?: string,
        createdByUserGuids?: Array<string>,
        assignedToUserGuids?: Array<string>,
        statusCodes?: string,
        interactionType?: string,
        direction?: string,
        isImportant?: boolean,
        dateFrom?: string,
        dateTo?: string,
        dateField?: string,
        primaryEmailSearch?: string,
        primaryPhoneSearch?: string,
        skip?: number,
        take?: number,
        ignoreFilters: boolean = false,
    ): CancelablePromise<ContactActivitySearchResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ContactActivity/{orgGuid}/Search',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'workflowDefinitionGuids': workflowDefinitionGuids,
                'includeArchived': includeArchived,
                'entityGuid': entityGuid,
                'contactNameSearch': contactNameSearch,
                'housingApplicationSearch': housingApplicationSearch,
                'createdByUserGuids': createdByUserGuids,
                'assignedToUserGuids': assignedToUserGuids,
                'statusCodes': statusCodes,
                'interactionType': interactionType,
                'direction': direction,
                'isImportant': isImportant,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'dateField': dateField,
                'primaryEmailSearch': primaryEmailSearch,
                'primaryPhoneSearch': primaryPhoneSearch,
                'skip': skip,
                'take': take,
                'ignoreFilters': ignoreFilters,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Aggregated "Task Due Dates" widget data for the Contact Activities Dashboard.
     * Counts the current user's open tasks (contact activities with a due date whose
     * workflow is not at an endpoint status), bucketed Active / Due Soon / Overdue and
     * broken down by interaction type. Scoped to the user across all orgs (the orgGuid
     * route value is used only for the access check).
     * @param orgGuid
     * @param dueSoonDays
     * @param targetUserGuid
     * @returns TaskDueDatesStatsDto OK
     * @throws ApiError
     */
    public taskStats(
        orgGuid: string,
        dueSoonDays: number = 3,
        targetUserGuid?: string,
    ): CancelablePromise<TaskDueDatesStatsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ContactActivity/{orgGuid}/TaskStats',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'dueSoonDays': dueSoonDays,
                'targetUserGuid': targetUserGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Aggregated "Client Communications" widget data for the Contact Activities Dashboard.
     * Counts the current user's contact activities per interaction type, comparing this
     * month (1st → today) with all of last month. Buckets by interaction date when present,
     * falling back to created date (interaction date is rarely populated). Scoped to the
     * user across all orgs (the orgGuid route value is used only for the access check).
     * @param orgGuid
     * @param targetUserGuid
     * @returns CommunicationStatsDto OK
     * @throws ApiError
     */
    public communicationStats(
        orgGuid: string,
        targetUserGuid?: string,
    ): CancelablePromise<CommunicationStatsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ContactActivity/{orgGuid}/CommunicationStats',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'targetUserGuid': targetUserGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
